import React from 'react';
import {Highlight} from 'react-instantsearch';
import PropTypes from 'prop-types';

export default function TeaserNode(props) {
  const { hit } = props;
  const hasImage =
    'styled_image_url' in hit &&
    hit.styled_image_url;
  const bundleLabel = hit.entity_bundle_processed || '';
  const placeholderVariant =
    bundleLabel.toLowerCase() === 'pagina' ? 'page' : null;
  const placeholderInitial =
    bundleLabel && bundleLabel.charAt(0) ? bundleLabel.charAt(0) : 'L';

  return (
    <a className="search-card search-card--node" href={hit.entity_alias} hrefLang="nl">
      <div className="search-card__media">
        {hasImage ? (
          <img
            src={hit.styled_image_url}
            alt={hit.content_title}
            loading="lazy"
          />
        ) : (
          <div
            className={`search-card__media-placeholder${placeholderVariant ? ` search-card__media-placeholder--${placeholderVariant}` : ''}`}
            aria-hidden="true"
          >
            {!placeholderVariant && <span>{placeholderInitial}</span>}
          </div>
        )}
      </div>

      <div className="search-card__content">
        <span className="search-card__badge">
          {hit.entity_bundle_processed}
        </span>

        <h3 className="search-card__title">
          <Highlight attribute="content_title" hit={hit} />
        </h3>

        {hit.content_body ? (
          <div
            className="search-card__excerpt"
            dangerouslySetInnerHTML={{ __html: hit.content_body }}
          />
        ) : null}

        <span className="search-card__cta">
          Meer informatie
        </span>
      </div>
    </a>
  );
}

TeaserNode.propTypes = {
  hit: PropTypes.object.isRequired,
};
